import { TIPO_ASIENTO } from "api/Types/TipoAsiento"
import { TFunction } from "i18next"

export const TIPOS_ASIENTOS = (t: TFunction) => [
  {
    tipo: TIPO_ASIENTO.APUNTE,
    descripcion: `${t("diario.asientosType.entryLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.FACTURA_EMITIDA,
    descripcion: `${t("diario.asientosType.invEmitLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.FACTURA_EMITIDA_RECTIFICATIVA,
    descripcion: `${t("diario.asientosType.invEmitRecLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.FACTURA_RECIBIDA,
    descripcion: `${t("diario.asientosType.invRecLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.FACTURA_RECIBIDA_RECTIFICATIVA,
    descripcion: `${t("diario.asientosType.invRecRecLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.GASTO,
    descripcion: `${t("diario.asientosType.costLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.NOMINA,
    descripcion: `${t("diario.asientosType.payrollLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.COBRO,
    descripcion: `${t("diario.asientosType.collectionLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.PAGO,
    descripcion: `${t("diario.asientosType.paymentLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.AMORTIZACION,
    descripcion: `${t("diario.asientosType.whitteOffLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.ASIENTO_REG_CIERRE,
    descripcion: `${t("diario.asientosType.asiRegCerrLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.ASIENTO_DE_APERTURA,
    descripcion: `${t("diario.asientosType.asiApeLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.ASIENTO_DE_CIERRE,
    descripcion: `${t("diario.asientosType.asiCieLabel")}`,
  },
  {
    tipo: TIPO_ASIENTO.LIQUIDACION_DE_IMPUESTOS,
    descripcion: `${t("diario.asientosType.liquidacionLabel")}`,
  },
]
